import {Component, Event, EventEmitter, h, Method, Prop, State, Watch} from '@stencil/core';
import {_debug} from '../../common/debugger/debugger';

@Component({
  tag: 'lb-idle-timer',
  shadow: true
})
export class IdleTimer {
  @Prop() events: string[] = ['keyup', 'mouseup', 'change'];
  @Prop() idleThresholdMs: number = 1800000; // 30 minutes in ms
  @Prop() promptThresholdMs: number = this.idleThresholdMs / 2;
  @Prop() countdownTick: number = 1000;

  private countdown: any; // the Interval
  private countdownInitialized: number = Date.now();
  
  @State() activityNoticed: number | null = null; // Date.now() at the time an activity was registered
  @State() remainingTime: number = this.idleThresholdMs;

  @Event() activity: EventEmitter;
  @Event() prompt: EventEmitter<number>;

  @Method() async reset() {
    this.countdownInitialized = Date.now();
    if(this.activityNoticed) this.activityNoticed = null;   
  }

  @Method() async restart() {
    _debug('idle-timer restart')
    this.registerEventListeners();
    this.initCountdown();
  }

  componentDidLoad() {
    _debug('idle-timer did load')
    this.registerEventListeners();
    this.initCountdown();
  }

  private registerEventListeners() {
    this.events.forEach((event) => {
      document.addEventListener(event, this.handleActivity);
    });
    window.addEventListener('focus', this.handleActivity);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  private handleActivity = () => {
    console.log('in lb idle timer handle activity activityNoticed:')
    console.log(this.activityNoticed)
    this.activityNoticed = Date.now();
  }

  private handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      this.handleActivity();
    }
  }

  @Watch('activityNoticed')
  handleActivityNoticedChange(newActivityNoticed: number | null) {
    console.log('newActivityNoticed:')
    console.log(newActivityNoticed)
    if (newActivityNoticed && this.remainingTime > 0 && this.remainingTime <= this.promptThresholdMs) {
      this.activity.emit();
      this.activityNoticed = null;
    }
  }

  private initCountdown() {
    _debug('initializing countdown in idle-timer')
    this.countdown = setInterval(() => {
       this.remainingTime = this.idleThresholdMs - (Date.now() - this.countdownInitialized);    
    }, this.countdownTick);   
  }

  @Watch('remainingTime')
  handleRemainingTimeChange(newRemainingTime: number) {
    _debug('remaining time in idle-timer', newRemainingTime)

    if (newRemainingTime <= this.promptThresholdMs) {
      if (this.activityNoticed) {
        this.activity.emit()
      } else {
        this.prompt.emit(newRemainingTime)
      }
    }
  }

  // disconnect is called when the component is being disconnected from the DOM
  // remove global intervals and event listeners

  disconnectedCallback() {
    _debug('idle-timer disconnect')
   this.shutDown();
  }

  @Method()
  async shutDown() {
    clearInterval(this.countdown);
    _debug('in idle-timer shutdown, this.countdown', this.countdown)
    this.unregisterEventListeners();
  }

  private unregisterEventListeners() {
    this.events.forEach((event) => {
      document.removeEventListener(event, this.handleActivity);
    });
    window.removeEventListener('focus', this.handleActivity);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }


  render() {
    return <slot /> 
  }
}
